// import SHARED from '../../../../constants';

import SHARED from '../../../constants';
import zip from '../../../../../assets/imgs/fileTypes/zip.png';
import rar from '../../../../../assets/imgs/fileTypes/rar.png';
import doc from '../../../../../assets/imgs/fileTypes/doc.png';
import pdf from '../../../../../assets/imgs/fileTypes/pdf.png';
import mp3 from '../../../../../assets/imgs/fileTypes/mp3.png';

import files from '../../../../../assets/imgs/fileTypes/files.svg';
import players from '../../../../../assets/imgs/fileTypes/players.svg';

import { AdminContext } from '../../../context/AdminContext';
import React, { useContext } from 'react';
import CreateImageSrc from '../../../functions/CreateImageSrc';
import styles from './styles.module.css';
import SharedFunc from '../../../functions/SharedFunc';

const RepliedMessage = ({ message, scrollToId, isJSON }) => {
  const { content, direction } = useContext(AdminContext);
  console.log('messagee==', message);
  return (
    <div
      className={`flex flex-row-reverse justify-start items-center  w-[100%] commentReply cursor-pointer w-full`}
      onClick={() => {
        console.log('id===', message?.replyId);
        scrollToId(message);
        // document
        //   ?.getElementById(message?.replyId)
        //   ?.scrollIntoView({
        //     behavior: 'smooth',
        //   });
      }}
    >
      <div
        className={`flex flex-col justify-start items-end

          `}
      >
        <p>{`${content.replyToUser} ${
          message?.reply?.roomUser?.channelUser?.channelName
            ? message?.reply?.roomUser?.channelUser?.channelName
            : message?.reply?.roomUser?.channelUser?.username
        }`}</p>
        {message?.reply?.message ? (
          <>
            {message?.reply?.typeId == 3 ? (
              <p className={``}>{JSON.parse(message?.reply?.message).name}</p>
            ) : (
              <>
                {message?.reply?.typeId == 4 ? (
                  <p>
                    {`${SHARED?.copy_URL}/video/play/${
                      JSON.parse(message?.reply?.message)?.uuid
                    }`}
                  </p>
                ) : (
                  <p>{message?.reply?.message}</p>
                )}
              </>
            )}
          </>
        ) : (
          <>
            <>
              {message?.reply?.file?.fileExtension?.type == 'image' && (
                <>
                  <img
                    className={`replyFile  ${styles.imageStyle} ${
                      direction == 'ltr' ? 'mr-auto' : 'ml-auto'
                    }`}
                    src={`${SHARED?.socketServerImage}${CreateImageSrc(
                      message?.reply?.file?.name
                    )}`}
                  />
                  {/* <p>{message?.reply?.file?.name}</p> */}
                </>
              )}
            </>
            <>
              {message?.reply?.file?.fileExtension?.type == 'video' && (
                <>
                  {/* <video
                    className={`replyFile ${styles.imageStyle} ${
                      direction == 'ltr' ? 'mr-auto' : 'ml-auto'
                    }`}
                    src={`${SharedFunc(
                      message?.reply?.file?.serverId,
                      'socketServerVideo'
                    )}${message?.reply?.file?.name}`}
                    // controls
                  /> */}
                  <img
                    className={`replyFile ${styles.imageStyle} ${
                      direction == 'ltr' ? 'mr-auto' : 'ml-auto'
                    }`}
                    // href={`${SHARED?.socketServerFile}${item?.file?.name}`}
                    // controls
                    src={players}
                  />
                  <p>{message?.reply?.file?.name}</p>
                </>
              )}
            </>
            {message?.reply?.file?.fileExtension?.type == 'music' && (
              <>
                <img
                  className={`replyFile ${styles.imageStyle} ${
                    direction == 'ltr' ? 'mr-auto' : 'ml-auto'
                  }`}
                  // href={`${SHARED?.socketServerFile}${item?.file?.name}`}
                  // controls
                  src={players}
                />
                <p>{message?.reply?.file?.name}</p>
              </>
            )}
            {message?.reply?.file?.fileExtension?.type == 'zip' && (
              <>
                <img
                  className={`replyFile ${styles.imageStyle} ${
                    direction == 'ltr' ? 'mr-auto' : 'ml-auto'
                  }`}
                  // href={`${SHARED?.socketServerFile}${item?.file?.name}`}
                  // controls
                  src={files}
                />
                <p>{message?.reply?.file?.name}</p>
              </>
            )}
            {message?.reply?.file?.fileExtension?.type == 'rar' && (
              <>
                <img
                  className={`replyFile ${styles.imageStyle} ${
                    direction == 'ltr' ? 'mr-auto' : 'ml-auto'
                  }`}
                  // href={`${SHARED?.socketServerFile}${item?.file?.name}`}
                  // controls
                  src={files}
                />
                <p>{message?.reply?.file?.name}</p>
              </>
            )}
            {message?.reply?.file?.fileExtension?.type == 'doc' && (
              <>
                <img
                  className={`replyFile ${styles.imageStyle} ${
                    direction == 'ltr' ? 'mr-auto' : 'ml-auto'
                  }`}
                  // href={`${SHARED?.socketServerFile}${item?.file?.name}`}
                  // controls
                  src={files}
                />
                <p>{message?.reply?.file?.name}</p>
              </>
            )}

            {message?.reply?.file?.fileExtension?.type == 'pdf' && (
              <>
                <img
                  className={`replyFile ${styles.imageStyle} ${
                    direction == 'ltr' ? 'mr-auto' : 'ml-auto'
                  }`}
                  // href={`${SHARED?.socketServerFile}${item?.file?.name}`}
                  // controls
                  src={files}
                />
                <p>{message?.reply?.file?.name}</p>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default RepliedMessage;
